import { useState } from "react"

import { PlatformOverview, type OverviewPeriod } from "@/components/dashboard/superadmin/PlatformOverview"
import { SuperAdminStats } from "@/components/dashboard/superadmin/SuperAdminStats"
import { Page, PageHeader, Segmented } from "@/components/superadmin/kit"
import { SuperAdminLayout } from "@/components/superadmin/SuperAdminLayout"

const periods: Array<{ value: OverviewPeriod; label: string }> = [
  { value: "month", label: "Mês" },
  { value: "quarter", label: "Trimestre" },
  { value: "year", label: "Ano" },
]

const SuperAdmin = () => {
  const [period, setPeriod] = useState<OverviewPeriod>("month")

  return (
    <SuperAdminLayout>
      <Page>
        <PageHeader
          title="Visão geral"
          description="Como a plataforma está hoje: contas, organizações, pendências e o comercial."
          actions={<Segmented value={period} onChange={setPeriod} options={periods} className="rounded-lg border border-border p-0.5" />}
        />
        <SuperAdminStats />
        <PlatformOverview period={period} />
      </Page>
    </SuperAdminLayout>
  )
}

export default SuperAdmin
